import classNames from 'classnames';
import FlexContainer from '../FlexContainer';
import styles from './AnimatedHide.module.scss';

/**
 * AnimatedHide
 *
 * @return {JSX.Element}
 */
const AnimatedHide = ({
  className,
  classNameWidth,
  isClosed,
  children,
  flex,
  ...rest
}) => {
  return (
    <FlexContainer
      className={classNames(
        styles.AnimatedHide,
        classNameWidth,
        isClosed && styles.AnimatedHide__isClosed,
        className,
        `${AnimatedHide.displayName}`
      )}
      row
      flex={flex}
    >
      <FlexContainer
        className={classNames(styles.Body, classNameWidth)}
        flex
        {...rest}
      >
        {children}
      </FlexContainer>
    </FlexContainer>
  );
};

AnimatedHide.displayName = 'AnimatedHide';

export default AnimatedHide;
